import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button, Container, makeStyles } from '@material-ui/core';
import mainStyles from '@/assets/js/mainStyles.js';
import usePage from '@/hooks/usePage.js';

const useStyles = makeStyles(mainStyles);

const Regulation = () => {
  const classes = useStyles();
  const history = useHistory();
  const { setTitle } = usePage();

  setTitle('Réglementation');

  return (
    <Container maxWidth="md">
      <Box className={classes.contentMW}>
        <Box align="center" className={classes.flexBoxColumn}>
          <Button
            className={classes.outlinedBtn}
            onClick={() => history.push(`regulation/implementation`)}
            variant="outlined"
            size="large"
          >
            Mise en œuvre
          </Button>
          <Button
            className={classes.outlinedBtn}
            onClick={() => history.push(`regulation/official-documentation`)}
            variant="outlined"
            size="large"
          >
            Documentation officielle
          </Button>
          <Button
            className={classes.outlinedBtn}
            onClick={() => history.push('regulation/configurators')}
            variant="outlined"
            size="large"
          >
            Vérification de mise en place
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default Regulation;
